import { render, staticRenderFns } from "./rightPreview.vue?vue&type=template&id=ba79ee70&scoped=true"
import script from "./rightPreview.vue?vue&type=script&lang=js"
export * from "./rightPreview.vue?vue&type=script&lang=js"
import style0 from "./rightPreview.vue?vue&type=style&index=0&id=ba79ee70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba79ee70",
  null
  
)

export default component.exports